import { ReplaceAroundStep, ReplaceStep, Step } from 'prosemirror-transform'
import { Transaction } from 'prosemirror-state'

// This function returns all form/to positions for each step in each tr in the
// input array mapped to the doc which is the result of applying all trs in order from 0 to
// trs.length - 1. It is useful to listen for changes in `appendTransaction`, e.g.
// to clean up comments or tasks efficiently or to join lists.
export const mappedStepPositions = (
  trs: Transaction[],
): { from: number; to: number; step: Step; tr: Transaction }[] => {
  return trs
    .map((tr, trIndex) => {
      if (!tr.docChanged) return null

      return tr.steps.map((step, stepIndex) => {
        if (!(step instanceof ReplaceStep || step instanceof ReplaceAroundStep)) return null

        const fromPosInDoc = trs
          .slice(trIndex + 1)
          .reduce((pos, aTr) => aTr.mapping.map(pos), tr.mapping.slice(stepIndex).map((step as any).from))
        const toPosInDoc = trs
          .slice(trIndex + 1)
          .reduce((pos, aTr) => aTr.mapping.map(pos), tr.mapping.slice(stepIndex).map((step as any).to))

        return { from: fromPosInDoc, to: toPosInDoc, step, tr }
      })
    })
    .flat()
    .filter(Boolean) as ReturnType<typeof mappedStepPositions>
}
